package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.selection.TextSelectionColors
import androidx.compose.material.Icon
import androidx.compose.material.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Search
import androidx.compose.material3.TextField
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.ic_search
import com.hyperether.goodjob.resources.search
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun SearchField(
    searchQuery: MutableState<String>
) {

    Column(
        modifier = Modifier.fillMaxWidth()
    ) {
        TextField(
            value = searchQuery.value,
            onValueChange = { searchQuery.value = it },
            placeholder = {
                Text(
                    fontSize = 14.toScaleSp(),
                    text = stringResource(Res.string.search),
                    color = Color.LightGray
                )
            },
            textStyle = TextStyle(fontSize = 14.toScaleSp()),
            modifier = Modifier
                .fillMaxWidth()
                .padding(start = 16.toScaleDp(), end = 16.toScaleDp())
                .border(1.toScaleDp(), Color.Gray, RoundedCornerShape(25.toScaleDp()))
                .clip(RoundedCornerShape(25.toScaleDp())),
            trailingIcon = {
                Icon(
                    imageVector = Icons.Default.Search,
                    contentDescription = "Search Icon"
                )
            },
            singleLine = true,
            colors = TextFieldDefaults.colors(
                unfocusedContainerColor = Color.Transparent,
                focusedContainerColor = Color.Transparent,
                selectionColors = TextSelectionColors(
                    backgroundColor = Color.Transparent,
                    handleColor = Color.Transparent
                ),
                focusedIndicatorColor = Color.Transparent,
                unfocusedIndicatorColor = Color.Transparent,
                disabledIndicatorColor = Color.Transparent
            )
        )
    }
}

@Composable
fun SearchMapWeb(
    searchQuery: MutableState<String>
) {
    BasicTextField(
        searchQuery.value,
        singleLine = true,
        textStyle = TextStyle(fontSize = 12.toScaleSp(), color = Color.Black),
        modifier = Modifier
            .width(226.toScaleDp())
            .height(45.toScaleDp())
            .background(Color.White, RoundedCornerShape(8.toScaleDp()))
            .border(1.toScaleDp(), BorderColor, RoundedCornerShape(8.toScaleDp()))
            .padding(8.toScaleDp()),
        onValueChange = {
            searchQuery.value = it
        },
        decorationBox = { innerTextField ->
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxSize()
            ) {
                Image(
                    modifier = Modifier.size(24.toScaleDp()),
                    painter = painterResource(Res.drawable.ic_search),
                    contentDescription = "Search"
                )
                Spacer(modifier = Modifier.width(8.toScaleDp()))
                Box(Modifier.weight(1f), contentAlignment = Alignment.CenterStart) {
                    if (searchQuery.value.isEmpty()) {
                        Text(
                            fontSize = 14.toScaleSp(),
                            text = stringResource(Res.string.search),
                            fontWeight = FontWeight.W400,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis,
                            color = Color.Gray,
                        )
                    }
                    innerTextField()
                }
            }
        }
    )
}